import goto from "./index";

export default {
  miniCourses() {
    goto.layer("mini-courses");
  },
};
